/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketlinkbuttontickets3Inputs */

const en_ticketlinkbuttontickets3 = /** @type {(inputs: Ticketlinkbuttontickets3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Button in the app: "Get Tickets"`)
};

const de_ticketlinkbuttontickets3 = /** @type {(inputs: Ticketlinkbuttontickets3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Button in der App: „Tickets kaufen“`)
};

/**
* | output |
* | --- |
* | "Button in the app: \"Get Tickets\"" |
*
* @param {Ticketlinkbuttontickets3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketlinkbuttontickets3 = /** @type {((inputs?: Ticketlinkbuttontickets3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketlinkbuttontickets3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketlinkbuttontickets3(inputs)
	return de_ticketlinkbuttontickets3(inputs)
});
export { ticketlinkbuttontickets3 as "ticketLinkButtonTickets" }